import { useQuery } from "@tanstack/react-query";
import { getSearchEduJabatan, getSearchEduKelas, getEduKelasById, getSearchEduPembelajaran, getSearchEduPendidikan, getSearchEduPenilaian, getSearchEduProfesi, getSearchEduUniversitas, getSearchEduJurusan, getSearchEduTahunAjaran, getSearchEduPeriode, getSearchEduBlokWaktu, } from "../../services";
export const useGetSearchEduJabatan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edujabatan", searchParams],
        queryFn: () => getSearchEduJabatan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduKelas = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edukelas", searchParams],
        queryFn: () => getSearchEduKelas(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduPembelajaran = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edupembelajaran", searchParams],
        queryFn: () => getSearchEduPembelajaran(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduPendidikan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edupendidikan", searchParams],
        queryFn: () => getSearchEduPendidikan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduPenilaian = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edupenilaian", searchParams],
        queryFn: () => getSearchEduPenilaian(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetEduPenilaianOptions = (kategori) => {
    return useQuery({
        queryKey: ["master", "edupenilaian-options", kategori],
        queryFn: async () => {
            const res = await getSearchEduPenilaian({
                page: 0,
                size: 1000,
                keyword: "",
                kategori: kategori
            });
            return res?.data || [];
        },
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduProfesi = (searchParams) => {
    return useQuery({
        queryKey: ["master", "eduprofesi", searchParams],
        queryFn: () => getSearchEduProfesi(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetEduKelasById = (id) => {
    return useQuery({
        queryKey: ["master", "edukelas", "detail", id],
        queryFn: () => getEduKelasById(id),
        enabled: !!id,
    });
};
export const useGetSearchEduUniversitas = (searchParams) => {
    return useQuery({
        queryKey: ["master", "eduuniversitas", searchParams],
        queryFn: () => getSearchEduUniversitas(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduJurusan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edujurusan", searchParams],
        queryFn: () => getSearchEduJurusan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduTahunAjaran = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edutahunajaran", searchParams],
        queryFn: () => getSearchEduTahunAjaran(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduPeriode = (searchParams) => {
    return useQuery({
        queryKey: ["master", "eduperiode", searchParams],
        queryFn: () => getSearchEduPeriode(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchEduBlokWaktu = (searchParams) => {
    return useQuery({
        queryKey: ["master", "edublokwaktu", searchParams],
        queryFn: () => getSearchEduBlokWaktu(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
